import { render, staticRenderFns } from "./guide-group-management.vue?vue&type=template&id=b8724542"
import script from "./guide-group-management.vue?vue&type=script&lang=js"
export * from "./guide-group-management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports